import React, { FC } from 'react';

import ErrorMessage from './ErrorMessage';

import ChangeNameAction from './ChangeNameAction';
import DeleteAction from './DeleteAction';
import AccessAction from './AccessAction';
import { WORKSPACE_ACTIONS } from 'src/constants/workspacesConstants';

type TActionContenteProps = {
  action: WORKSPACE_ACTIONS;
  isError: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onErrorClick: () => void;
  errorMessage: string | null;
  deleteText: string;
  inputValue?: Record<string, string>;
  nameValue?: string;
};

const ActionContent: FC<TActionContenteProps> = ({
  action,
  isError,
  onClose,
  errorMessage,
  onConfirm,
  deleteText,
  inputValue,
  onErrorClick,
  nameValue
}) => {
  if (isError) {
    return <ErrorMessage onClick={onErrorClick} message={errorMessage} />;
  }

  if ([WORKSPACE_ACTIONS.CREATE_WORKSPACE, WORKSPACE_ACTIONS.EDIT_WORKSPACE].includes(action)) {
    return <ChangeNameAction action={action} onConfirm={onConfirm} onClose={onClose} nameValue={nameValue} />;
  }

  if (action === WORKSPACE_ACTIONS.DELETE) {
    return <DeleteAction onConfirm={onConfirm} onClose={onClose} text={deleteText} />;
  }

  if ([WORKSPACE_ACTIONS.GRANT_ACCESS, WORKSPACE_ACTIONS.EDIT_ACCESS].includes(action)) {
    return <AccessAction onConfirm={onConfirm} onClose={onClose} action={action} inputValue={inputValue} />;
  }

  return null;
};

export default ActionContent;
